module.exports = __webpack_public_path__ + "static/img/projects-swat-kats.f90731d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects-swat-kats.png
// module id = dCEP
// module chunks = 1